import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global fetch base override: allows local UI to call a remote backend when
// REACT_APP_API_BASE is provided. This prefixes any request that begins with
// '/api' to the configured base URL.
// BUT: Don't override if running on localhost (local development)
const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const explicitApiBase = process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim();
if (explicitApiBase && !isLocalhost) {
  // Only override fetch when NOT on localhost (for remote testing)
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    try {
      const isString = typeof input === 'string';
      const url = isString ? input : (input && input.url) || '';
      if (isString && url.startsWith('/api')) {
        const rewritten = explicitApiBase.replace(/\/$/, '') + url;
        return originalFetch(rewritten, init);
      }
    } catch (_) {
      /* no-op */
    }
    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
